import { LabeledValue, PopoverOpenButton } from "@msys/ui";
import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { capitalize } from "lodash-es";
import { useSnackbar } from "notistack";
import React from "react";
import { Props2NonComputed } from "../../../clients/graphqlTypes.js";
import { copyTextToClipboard } from "../addresses/helpers.js";
import { getPropertyType } from "../doc-items/properties.js";

interface Props {
  property: Props2NonComputed;
}

export const PropertyInfoIconButton = ({ property }: Props) => {
  const { t } = useTranslate(["Global"]);
  const { enqueueSnackbar } = useSnackbar();
  return (
    <PopoverOpenButton
      content={
        <Stack
          direction={"column"}
          spacing={1}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          sx={{
            padding: 1,
            minWidth: 280,
            maxWidth: 320,
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: "center",
            }}
          >
            <LabeledValue label={t("Key", { ns: "Global" })}>
              {property.key}
            </LabeledValue>
            <IconButton
              size="small"
              color="secondary"
              onClick={async () => {
                await copyTextToClipboard(property.key);
                enqueueSnackbar(
                  t("Copied to clipboard", {
                    ns: "Global",
                  })
                );
              }}
            >
              <Tooltip title={t("Copy to clipboard", { ns: "Global" })}>
                <ContentCopyIcon />
              </Tooltip>
            </IconButton>
          </Stack>
          <LabeledValue label={t("Label", { ns: "Global" })}>
            {property.label}
          </LabeledValue>
          <LabeledValue label={t("Type", { ns: "Global" })}>
            {capitalize(getPropertyType(property))}
          </LabeledValue>
        </Stack>
      }
    >
      <IconButton
        color="secondary"
        size="small"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Tooltip
          title={t("Show info", {
            ns: "Global",
          })}
        >
          <InfoOutlineIcon />
        </Tooltip>
      </IconButton>
    </PopoverOpenButton>
  );
};
